import { RefObject, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useTableId = (ref: RefObject<HTMLTableElement>) => {
    const { pathname } = useLocation();
    const [id, setId] = useState<string | undefined>();

    useEffect(() => {
        const nodes = document.querySelectorAll(`[data-table-givebutter]`);

        let index = 0;
        let possibleCustomId = '';
        nodes.forEach((value, i) => {
            if (ref.current === value) {
                index = i;
                possibleCustomId = ref.current?.id ?? '';
            }
        });

        const id = `${pathname}-${index}-${possibleCustomId}`;
        setId(id);
    }, [pathname, ref]);

    return id;
};

export { useTableId };
